/**
 * Per-route <head> metadata. routes.json is shared with the build scripts
 * (prerender-routes.mjs, check-dist-quality.mjs), so the static HTML a crawler
 * receives and the title the SPA sets after navigation always agree.
 */
import routesFile from './routes.json'

export interface RouteMeta {
  path: string
  title: string
  description: string
  /** false => noindex and kept out of sitemap.xml */
  index: boolean
  /** true => AdSense loader / units allowed (content pages only) */
  ads: boolean
  prerender: boolean
}

export const SITE_ORIGIN: string = routesFile.site
export const ROUTES: RouteMeta[] = routesFile.routes
export const NOT_FOUND: RouteMeta = routesFile.notFound

/** '/about/' -> '/about', '' -> '/' */
export function normalizePath(pathname: string): string {
  const p = (pathname || '/').split(/[?#]/)[0]
  if (p === '/' || p === '') return '/'
  return p.replace(/\/+$/, '') || '/'
}

export function routeMetaFor(pathname: string): RouteMeta {
  const path = normalizePath(pathname)
  return ROUTES.find((r) => r.path === path) ?? NOT_FOUND
}

/** AdSense loader and ad units are only allowed on routes flagged ads:true. */
export function adsAllowedOn(pathname: string): boolean {
  return routeMetaFor(pathname).ads === true
}

export function canonicalUrl(pathname: string): string {
  const path = normalizePath(pathname)
  return path === '/' ? `${SITE_ORIGIN}/` : `${SITE_ORIGIN}${path}`
}
